import { render } from "./SpotSearchBox.vue?vue&type=template&id=afe2091e&scoped=true"
import script from "./SpotSearchBox.vue?vue&type=script&lang=js"
export * from "./SpotSearchBox.vue?vue&type=script&lang=js"

import "./SpotSearchBox.vue?vue&type=style&index=0&id=afe2091e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe2091e"]])

export default __exports__